export const START_LISTENING = 'EVENTTICKER/START_LISTENING';
export const STOP_LISTENING = 'EVENTTICKER/STOP_LISTENING';
export const SET_START_DATE = 'EVENTTICKER/SET_START_DATE';
export const ADD_EVENT = 'EVENTTICKER/ADD_EVENT';
export const APPEND_EVENT = 'EVENTTICKER/APPEND_EVENT';
export const START_LOADING_EVENTS = 'EVENTTICKER/START_LOADING_EVENTS';
export const DONE_LOADING_EVENTS = 'EVENTTICKER/DONE_LOADING_EVENTS';
export const START_SELECT_OE = 'EVENTTICKER/START_SELECT_OE';
export const DONE_SELECT_OE = 'EVENTTICKER/DONE_SELECT_OE';
export const APPEND_OE_EVENT = 'EVENTTICKER/APPEND_OE_EVENT';
export const UNSELECT_OE = 'EVENTTICKER/UNSELECT_OE';
export const START_SEARCH = 'EVENTTICKER/START_SEARCH';
export const DONE_SEARCH = 'EVENTTICKER/DONE_SEARCH';
export const CLOSE_SEARCH = 'EVENTTICKER/CLOSE_SEARCH';